import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useEditPage from 'hooks/useEditPage';
const PaymentsEditPage = (props) => {
		const app = useApp();
	// form validation schema
	const validationSchema = yup.object().shape({
		student_id: yup.string().required().label("Student Id"),
		course_id: yup.string().required().label("Course Id"),
		payment_date: yup.string().required().label("Payment Date"),
		amount: yup.number().required().label("Amount"),
		payment_method: yup.string().required().label("Payment Method"),
		payment_status: yup.string().required().label("Payment Status")
	});
	// form default values
	const formDefaultValues = {
		student_id: '', 
		course_id: '', 
		payment_date: "(getdate())", 
		amount: '', 
		payment_method: '', 
		payment_status: '', 
	}
	//where page logics resides
	const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
	//destructure and grab what we need
	const { formData, handleSubmit, submitForm, pageReady, loading, saving, apiRequestError, inputClassName } = pageController
	//Event raised on form submit success
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/payments`);
		}
	}
	// loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	//display error page 
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	//page is ready when formdata loaded successfully
	if(pageReady){
		return (
<main id="PaymentsEditPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="Edit Payment"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema} 
                            onSubmit={(values, actions) => {
                            submitForm(values);
                            }
                            }
                            >
                            { (formik) => {
                            return (
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Student Id *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/student_id_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="student_id"     optionLabel="label" optionValue="value" value={formik.values.student_id} onChange={formik.handleChange} options={response} label="Student Id"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.student_id)}   />
                                                    <ErrorMessage name="student_id" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Course Id *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/course_id_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="course_id"     optionLabel="label" optionValue="value" value={formik.values.course_id} onChange={formik.handleChange} options={response} label="Course Id"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.course_id)}   />
                                                    <ErrorMessage name="course_id" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Payment Date *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="payment_date" showButtonBar className={inputClassName(formik?.errors?.payment_date)} dateFormat="yy-mm-dd" value={formik.values.payment_date} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="payment_date" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Amount *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="amount"  onChange={formik.handleChange}  value={formik.values.amount}   label="Amount" type="number" placeholder="Enter Amount"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.amount)} />
                                                <ErrorMessage name="amount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Payment Method *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Dropdown  name="payment_method"     optionLabel="label" optionValue="value" value={formik.values.payment_method} onChange={formik.handleChange} options={app.menus.paymentMethod} label="Payment Method"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.payment_method)}   />
                                                <ErrorMessage name="payment_method" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Payment Status *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Dropdown  name="payment_status"     optionLabel="label" optionValue="value" value={formik.values.payment_status} onChange={formik.handleChange} options={app.menus.paymentStatus} label="Payment Status"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.payment_status)}   />
                                                <ErrorMessage name="payment_status" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)}  type="submit" label="Update" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            );
                            }
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}
PaymentsEditPage.defaultProps = {
	primaryKey: 'payment_id',
	pageName: 'payments',
	apiPath: 'payments/edit',
	routeName: 'paymentsedit',
	submitButtonLabel: "Update",
	formValidationError: "Form is invalid",
	formValidationMsg: "Please complete the form",
	msgTitle: "Update Record",
	msgAfterSave: "Record updated successfully",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default PaymentsEditPage;
